import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/configuracao/modelos-etiqueta/form')({
  component: ModeloEtiquetaFormLayout,
});

function ModeloEtiquetaFormLayout() {
  return <Outlet />;
}
